import React from "react"
import { MetaTags } from "@digits-shared/components/MetaTags/MetaTags"

export const PWAMetaTags: React.FC = () => (
  <MetaTags>
    {/* Icons */}
    <link
      rel="icon"
      type="image/png"
      sizes="32x32"
      href={require("static/head/frontend-favicon-32x32.png?url")}
    />
    <link
      rel="icon"
      type="image/png"
      sizes="16x16"
      href={require("static/head/frontend-favicon-16x16.png?url")}
    />
    <meta
      name="msapplication-config"
      content={require("static/head/frontend-browserconfig.xml?url")}
    />
    <meta name="msapplication-TileColor" content="#CCDBFF" />

    {/* Mobile */}
    <meta name="viewport" content="width=device-width, user-scalable=no, viewport-fit=cover" />
    <meta name="theme-color" content="#FCFBFF" />
    <link rel="manifest" href={require("static/head/frontend-site.webmanifest?url")} />

    {/* iOS PWA */}
    <meta name="mobile-web-app-capable" content="yes" />
    <meta name="apple-mobile-web-app-capable" content="yes" />
    <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
    <meta name="apple-mobile-web-app-title" content="Digits" />

    <link
      rel="apple-touch-icon"
      sizes="180x180"
      href={require("static/head/frontend-apple-touch-icon.png?url")}
    />
    <link
      rel="mask-icon"
      href={require("static/head/frontend-safari-pinned-tab.svg?url")}
      color="#30FEBF"
    />

    {/*   https://www.ios-resolution.com/  */}

    {/* iPhone 16 Pro Max */}
    <link
      rel="apple-touch-startup-image"
      href={require("static/head/ios-splash-1320x2868.png?url")}
      media="(device-width: 440px) and (device-height: 956px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"
    />

    {/* iPhone 16 Pro */}
    <link
      rel="apple-touch-startup-image"
      href={require("static/head/ios-splash-1206x2622.png?url")}
      media="(device-width: 402px) and (device-height: 874px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"
    />

    {/* iPhone 16 Plus, 15 Plus, iPhone 15 Pro Max */}
    <link
      rel="apple-touch-startup-image"
      href={require("static/head/ios-splash-1290x2796.png?url")}
      media="(device-width: 430px) and (device-height: 932px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"
    />

    {/* iPhone 16, 15, 15 Pro */}
    <link
      rel="apple-touch-startup-image"
      href={require("static/head/ios-splash-1179x2556.png?url")}
      media="(device-width: 393px) and (device-height: 852px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"
    />
  </MetaTags>
)
